import React from 'react'
import classnames from 'classnames'
import Cost from './cost'

const ToolbarMenuItem = ({
    amount,
    className,
    disabled,
    hidden,
    iconClassName,
    id,
    image,
    label,
    onClick,
    positive,
}) => {
    if (hidden) {
        return null
    }
    return (
        <button
            type="button"
            data-label={label}
            disabled={disabled}
            className={classnames('toolbar__menu-item', className, {
                'toolbar__menu-item--disabled': disabled,
            })}
            onClick={onClick}
        >
            <img
                className={classnames('toolbar__icon', iconClassName)}
                src={image}
                alt={id}
            />
            {!!amount ? <Cost amount={amount} positive={positive} /> : null}
        </button>
    )
}

export default ToolbarMenuItem
